const description = {
  "Supply Chain":
    "Employee Twins in Supply Chain automate tasks such as inventory management, demand forecasting, procurement, and logistics optimization to streamline operations, minimize waste, and reduce costs.",
  Finance:
    "Employee Twins in Finance focus on tasks such as financial reporting, budgeting, tax compliance, record-to-report processes, and treasury operations. They enhance accuracy and efficiency in fiscal management.",
  Marketing:
    "Employee Twins in Marketing support strategic campaigns, data analysis, customer insights generation, brand management, and promotion optimization, contributing to better alignment with consumer trends.",
  "HR Services":
    "For HR Services, Employee Twins assist in payroll processing, talent acquisition, onboarding, rewards management, compliance training, and skills development, providing smooth workflows and reducing administrative burden.",
  "HAP Products":
    "This category specializes in automating functions related to Health and Personal Care (HAP) product operations such as R&D, quality assurance processes, regulatory compliance, and market deployment strategies.",
};
export default description;

